import React from 'react';
import TrimSpecifications from './TrimSpecifications';
import NotImplemented from '../NotImplemented';
import { variant1, variant2, variant3, variant4 } from './service/constants';
import { HONDA_SITE_NAME, ACURA_SITE_NAME, PSP_SITE_NAME, PE_SITE_NAME } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
import { isEmpty } from '../../utils/object';
import { mapPSPFields } from './service/utils';
var TrimSpecificationsMap = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var _r = _a.tabsParams, tabsParams = _r === void 0 ? {} : _r, fields = _a.fields, rendering = _a.rendering;
    var appName = useAppName();
    if (!fields || isEmpty(fields) || !((_b = fields === null || fields === void 0 ? void 0 : fields.data) === null || _b === void 0 ? void 0 : _b.value)) {
        return null;
    }
    var variant;
    var vehicleType;
    var mappedFields = ((_c = fields === null || fields === void 0 ? void 0 : fields.data) === null || _c === void 0 ? void 0 : _c.value) || {};
    var paymentOptions = {
        paymentMethod: ((_g = (_f = (_e = (_d = fields === null || fields === void 0 ? void 0 : fields.data) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.paymentMethod) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.toLowerCase()) || 'finance',
        paymentFrequency: ((_l = (_k = (_j = (_h = fields === null || fields === void 0 ? void 0 : fields.data) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.paymentFrequency) === null || _k === void 0 ? void 0 : _k.value) === null || _l === void 0 ? void 0 : _l.toLowerCase()) || 'weekly',
    };
    switch (appName) {
        case ACURA_SITE_NAME:
            variant = variant2;
            break;
        case HONDA_SITE_NAME:
            variant = variant1;
            break;
        case PSP_SITE_NAME:
            mappedFields = mapPSPFields(mappedFields);
            vehicleType = (_q = (_p = (_o = (_m = mappedFields === null || mappedFields === void 0 ? void 0 : mappedFields.modelYear) === null || _m === void 0 ? void 0 : _m.fields) === null || _o === void 0 ? void 0 : _o.category) === null || _p === void 0 ? void 0 : _p.vehicleType) === null || _q === void 0 ? void 0 : _q.name;
            variant = variant3;
            break;
        case PE_SITE_NAME:
            variant = variant4;
            break;
        default:
            return React.createElement(NotImplemented, { name: "TrimSpecification" });
    }
    return (React.createElement(TrimSpecifications, { appNameConfig: { paymentOptions: paymentOptions }, componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, fields: mappedFields, tabsParams: tabsParams, variant: variant, vehicleType: vehicleType }));
};
export default TrimSpecificationsMap;
